"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceFeedStarknetContractAdapter = void 0;
const starknet_utils_1 = require("../starknet-utils");
class PriceFeedStarknetContractAdapter {
    contract;
    constructor(contract) {
        this.contract = contract;
    }
    async getPriceAndTimestamp() {
        const response = await this.contract.call("read_price_and_timestamp");
        const values = (0, starknet_utils_1.extractNumbers)(Object.values(response));
        return {
            value: values[0],
            timestamp: values[1],
        };
    }
}
exports.PriceFeedStarknetContractAdapter = PriceFeedStarknetContractAdapter;
//# sourceMappingURL=PriceFeedStarknetContractAdapter.js.map